import {
  Box,
  Button,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import type { StravaAccount } from 'core';
import type { FC } from 'react';

interface Props {
  account?: StravaAccount;
  onForgetAccountClick: () => void;
  onOnlyRunsChanged: () => void;
  onlyRuns: boolean;
}

const activityAccessLabel = (
  activityAccess: StravaAccount['activityAccess'],
): string | undefined => {
  if (activityAccess === 'all') return 'public and private activities';
  if (activityAccess === 'public') return 'public activities only';
  if (activityAccess === 'none') return 'no activity access';
  return undefined;
};

export const StravaAccountHeader: FC<Props> = ({
  account,
  onForgetAccountClick,
  onOnlyRunsChanged,
  onlyRuns,
}) => (
  <Stack spacing={2}>
    <Box
      display="flex"
      flex={1}
      flexDirection={{ xs: 'column', sm: 'row' }}
      gap={2}
      justifyContent="space-between"
    >
      <Typography variant="h3">Import Activity from Strava</Typography>
      <FormControlLabel
        control={<Switch checked={onlyRuns} onChange={onOnlyRunsChanged} />}
        label="Only Runs"
        labelPlacement="start"
        sx={{ alignSelf: { xs: 'flex-start', sm: 'center' }, m: 0 }}
      />
    </Box>
    {account ? (
      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        gap={1}
        justifyContent="space-between"
      >
        <Typography color="text.secondary" variant="body2">
          Connected to Strava as{' '}
          <Typography component="span" color="text.primary" variant="body2">
            {account.name}
          </Typography>
          {activityAccessLabel(account.activityAccess) ? (
            <> ({activityAccessLabel(account.activityAccess)})</>
          ) : null}
        </Typography>
        <Button
          color="error"
          onClick={onForgetAccountClick}
          size="small"
          sx={{ alignSelf: { xs: 'flex-start', sm: 'center' } }}
          variant="outlined"
        >
          Forget Account
        </Button>
      </Box>
    ) : null}
  </Stack>
);
